import { type VisibilityAccessRoleRef } from '@blaze-shared/elements-domain';
import { mergeDefinedIntoArray } from '@blaze-shared/shared-util';

import { extractElementContentActionWorkflowRef } from '../../canvas-elements/element-model/props-extractor';
import { PropsExtractor } from '../__base/props-extractor';

export class NotificationButtonPropsExtractor extends PropsExtractor<'notificationButton'> {
  override getVisibilityAccessRolesRefs(): VisibilityAccessRoleRef[] {
    return mergeDefinedIntoArray(
      ...super.getVisibilityAccessRolesRefs(),
      ...extractElementContentActionWorkflowRef(this.props?.content?.action),
    );
  }
}
